import React from 'react';
import EditBrandsComponent from '../../../Components/Brands/EditBrands';

export default function EditBrands() {
    return (
        <div className='page-body'>
            <EditBrandsComponent />
        </div>
    );
}